import { render, staticRenderFns } from "./MembersAndShareholdingSubscribers.vue?vue&type=template&id=0181f353&scoped=true&"
import script from "./MembersAndShareholdingSubscribers.vue?vue&type=script&lang=js&"
export * from "./MembersAndShareholdingSubscribers.vue?vue&type=script&lang=js&"
import style0 from "./MembersAndShareholdingSubscribers.vue?vue&type=style&index=0&id=0181f353&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0181f353",
  null
  
)

export default component.exports